// The analysis endpoint has a 6 MB request-body limit. Base64 adds roughly a
// third, so leave room for the JSON envelope and authentication metadata.
export const MAX_UPLOAD_IMAGE_BYTES = 4_000_000;

function asDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read this photo. Please try another.'));
    reader.readAsDataURL(file);
  });
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => { URL.revokeObjectURL(url); resolve(image); };
    image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not open this photo. Please try another.')); };
    image.src = url;
  });
}

function jpegBlob(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Could not prepare this photo. Please try another.'));
    }, 'image/jpeg', quality);
  });
}

export async function preparePhotoForAnalysis(file, maxBytes = MAX_UPLOAD_IMAGE_BYTES) {
  // Re-encode every upload so stored copies do not retain camera EXIF metadata.
  const image = await loadImage(file);
  let longestSide = Math.min(2200, Math.max(image.naturalWidth, image.naturalHeight));
  for (let attempt = 0; attempt < 5; attempt += 1) {
    const scale = longestSide / Math.max(image.naturalWidth, image.naturalHeight);
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Could not prepare this photo. Please try another.');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await jpegBlob(canvas, attempt < 2 ? 0.9 : 0.85);
    if (blob.size <= maxBytes) return asDataUrl(blob);
    longestSide = Math.round(longestSide * 0.8);
  }
  throw new Error('This photo is too large to analyse. Please choose another.');
}
